export default __webpack_public_path__ + "static/media/p12.37390f4e.JPG";